import { render, staticRenderFns } from "./fileTech.vue?vue&type=template&id=54429f90&scoped=true&"
import script from "./fileTech.vue?vue&type=script&lang=js&"
export * from "./fileTech.vue?vue&type=script&lang=js&"
import style0 from "./fileTech.vue?vue&type=style&index=0&id=54429f90&scoped=true&lang=css&"
import style1 from "./fileTech.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54429f90",
  null
  
)

export default component.exports